import { Component, Input, Output, EventEmitter } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Case } from 'app/application/interfaces/case';
import { TranslateModule } from '@ngx-translate/core';
import { MatIconModule } from '@angular/material/icon';

@Component({
  selector: 'app-all-applications-recent',
  standalone: true,
  imports: [CommonModule,TranslateModule,MatIconModule],
  templateUrl: './all-applications-recent.component.html',
  styleUrls: ['./all-applications-recent.component.scss']
})
export class AllApplicationsRecentComponent {
  @Input() paginatedApplications: Case[] = [];
  @Output() viewDetailsClicked = new EventEmitter<string>();

  constructor(){
  }

  viewAppDetails(caseId: string) {
    this.viewDetailsClicked.emit(caseId);
  }

   convertToTimeFormat(dateTimeString: string) {
        return dateTimeString.split(' ')[1];
    }

      formatDate(inputTime: string) {
        let dateObj = new Date(inputTime);
        let month = dateObj.toLocaleString('en-us', { month: 'short' });
        let day = dateObj.getDate();
        let year = dateObj.getFullYear();
        let formattedDate = day + ' ' + month + ' ' + year;

        return formattedDate;
    }
}
